import React, {useState, useEffect} from "react";
import { isEmpty, capitalize, join, startCase, toLower } from "lodash";
import scrollIntoView from 'scroll-into-view-if-needed'
import * as qs from "query-string"
import $ from "jquery"

//export const mail_form_url = `${process.env.GATSBY_CLOUD_URL}/api/form`;
export const mail_form_url = `/api/gatsby-theme-starberry-lomondgroup/form`;
export const send_friend_mail_form_url = `/api/gatsby-theme-starberry-lomondgroup/send-to-friend-property-form`;
export const payment_form_url = `/api/gatsby-theme-starberry-lomondgroup/payment-form`;
export const rent_form_url = `/api/gatsby-theme-starberry-lomondgroup/rent-form`;
export const rent_form_url_linley = `/api/gatsby-theme-starberry-lomondgroup/rent-form-linley`;
export const tenant_offer_form_url_linley = `/api/gatsby-theme-starberry-lomondgroup/tenant-offer-form-linley`;
export const rent_form_url_bv = `/api/gatsby-theme-starberry-lomondgroup/rent-form-brandvaughan`;
export const rent_form_url_bvstudents = `/api/gatsby-theme-starberry-lomondgroup/rent-form-bvstudents`;

export const Mail_Function = (formvalues) => {
  window.fetch(`${mail_form_url}`, {
    method: `POST`,
    mode: "no-cors",
    headers: {
      'Access-Control-Allow-Origin': '*',
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const Rent_Mail_Function = (formvalues) => {
  window.fetch(`${rent_form_url}`, {
    method: `POST`,
    mode: "no-cors",
    headers: {
      'Access-Control-Allow-Origin': '*',
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const Rent_Mail_Function_Linley = (formvalues) => {
  window.fetch(`${rent_form_url_linley}`, {
    method: `POST`,
    mode: "no-cors",
    headers: {
      'Access-Control-Allow-Origin': '*',
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const Tenant_Offer_Mail_Function_Linley = (formvalues) => {
  window.fetch(`${tenant_offer_form_url_linley}`, {
    method: `POST`,
    mode: "no-cors",
    headers: {
      'Access-Control-Allow-Origin': '*',
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const Rent_Mail_Function_BV = (formvalues) => {
  window.fetch(`${rent_form_url_bv}`, {
    method: `POST`,
    mode: "no-cors",
    headers: {
      'Access-Control-Allow-Origin': '*',
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const Rent_Mail_Function_BVStudents = (formvalues) => {
  window.fetch(`${rent_form_url_bvstudents}`, {
    method: `POST`,
    mode: "no-cors",
    headers: {
      'Access-Control-Allow-Origin': '*',
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const SendFriend_Mail = (formvalues) => {
    window.fetch(`${send_friend_mail_form_url}`, {
      method: `POST`,
      mode: "no-cors",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: qs.stringify(formvalues),
    })
}

export const Payment_Mail = (formvalues) => {
  window.fetch(`${payment_form_url}`, {
    method: `POST`,
    mode: "no-cors",
    headers: {
      'Access-Control-Allow-Origin': '*',
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const youtube_parser =(url) => {
  var regExp = /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
  var match = url.match(regExp);
  return (match && match[1].length==11)? match[1] : false;
}

export const uniqueID = () => {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

  for (var i = 0; i < 20; i++){
      text += possible.charAt(Math.floor(Math.random() * possible.length));
  }      
  return text; 
}

export  const phoneNumberValidation = (num) =>  {
    if(num){
      return num.toString().replace(/[^0-9\+ ]+/g, "")
    } else {
      return false;
    } 
  }

export const numberOnly = (value) => {
    if(value){
        if(!/^[0-9]+$/.test(value)){
        //alert("Please only enter numeric characters.")
        return "Please enter  only numeric characters.";
        }
    }  
}

export const externalURL = (link) => {
    if (link.indexOf("http://") === 0 || link.indexOf("https://") === 0) {
        return true;
    }
    else{
        return false;
    }
}

/**Add scripts tag */
export const AppendScript = (url, id, callback) => {
    if (document.getElementById(id) === null) {
      var e = document.createElement("script");
      e.src = url;
      e.id = id;
      e.async = true;
      e.defer = true;
      e.type = "text/javascript";
      e.addEventListener('load', callback(true));
      document.getElementsByTagName("body")[0].appendChild(e);
    }else{
        callback(false)
    }

}
/**Start with */
export const startsWith = (str, word) => {
    return str?.lastIndexOf(word, 0) === 0;
}

/**Eng with */
export const endsWith = (str, word) => {
    return str?.slice(-1) === word;
}

/**Scroll To Top */
export const ScrollToTop = (ref, top = 100) => {
    scrollIntoView(ref, {
        behavior: actions =>
        actions.forEach(({ el }) => {
            el.scrollTop = top
        }),
    })
}

/**Scroll To Div */
export const ScrollToDiv = (div_id) => {
    $('html, body').animate({
        scrollTop: $("#"+div_id).offset().top - 140
    }, 1000);
}

/** currency format conversion */
export const currencyFormat = (num, currency = '£', withSpace = false) => {
    var filterNum = filterNumber(num);
    if (!filterNum) {
        return `${currency} 0`
    }
    if (withSpace) {
        return `${currency} ${new Intl.NumberFormat("en-US", {}).format(filterNum)}`
    } else {
        return `${currency}${new Intl.NumberFormat("en-US", {}).format(filterNum)}`
    }

}

/** Get number only */
export const filterNumber = (str) => {
    if (!str) return 0
    str = str.toString()
    return parseInt(str.replace(/[^\d.]/g, ""), 10)
}

/** Get number format with out currency*/
export const numberFormat = num => {
    if (!num) return 0
    return new Intl.NumberFormat("en-US", {}).format(num)
}

/** Get url params*/
export const getUrlParams = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return Object.fromEntries(urlSearchParams.entries());
}

/** string include spl character*/
export const isIncludeSplChar = (text) => {
    const format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return format.test(text);
}
/** string to captilize*/
export const toCapitalize = (str) => {
    if (!isEmpty(str)) {
        return startCase(toLower(str.replace(/[^a-zA-Z0-9]/g, " ").replace(/\s+/g, ' ')));
    }
    return str;
}

/** string remove all special characters*/
export const removeSpecialChar = (val, symbol = '-') => {
    if (!isEmpty(val)) {
        return val.replace(/[^\w\s]/gi, ' ').replace(/\s\s+/g, ' ').replace(/ /gi, symbol).toLowerCase()
    }
    return val;
}

/** Get url params*/
export const squareFeetToMeter = (val) => {
    let meter = (0.09290304 * val)
    return `${Math.round(meter)}`;
}

export const isNotEmpty = (val) => {
    if (typeof val != "undefined" && val !== null && val !== "") {
        return true
    }
    return false;
}

/** GTM Event Trigger*/
export const gtmEvent = ({ event = "formSubmit", formType, formName }) => {
    if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        'event': 'formSubmit',
        'formType': `form-${formType}`,
        'formId': `form-${formType}`,
        'formName': formName,
        'formLabel': formName
        });
    }
}

export const addCommas = num => num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";

export  const removeNonNumeric = num => num ? num.toString().replace(/[^0-9]+/g, "") : "";

export  const numericWithDecimal = num => num ? num.toString().replace(/[^0-9\.]+/g, "") : "";

export const getPriceStr = (min, max) => {
    let priceStr = '';
    if (min && max) {
      priceStr = `between ${currencyFormat(min)} and ${currencyFormat(max)}`;
    } else if (max) {
      priceStr = `below ${currencyFormat(max)}`;
    } else if (min) {
      priceStr = `above ${currencyFormat(min)}`;
    }
    return priceStr;
}

export const getOffset = ( el ) => {
    let _x = 0;
    let _y = 0;
    while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
        _x += el.offsetLeft - el.scrollLeft;
        _y += el.offsetTop - el.scrollTop;
        el = el.offsetParent;
    }
    return { top: _y, left: _x };
  }

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }
  
  export const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    return windowDimensions;
  }


  export const subtractYears = (date, years) => {
    date.setFullYear(date.getFullYear() - years);

    return date;
  }

  export const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}